export default __webpack_public_path__ + "static/media/b03.3794fa87.jpg";